import React from 'react';
import './index.scss'
import Heading from "../../atoms/heading/Heading";
import { API } from '../../../constants';
import LazyLoadImage from '../../atoms/image/Image';

const AdditionalCommentsComponent = ({ data }) => {
  const imageSrc = data.image? API + '/images/' + data.image: null;
  
  return( data &&
    <div className="text-center ">
      <div className="section__title text-sm font-medium pb-2"> {data.subHeading} </div>
      <Heading> {data.name} </Heading>
      {
        imageSrc && (<div className="mx-auto max-w-3xl md:max-w-3xl lg:max-w-3xl 2xl:max-w-3xl 3xl:max-w-3xl md:mx-auto lg:mx-auto 2xl:mx-auto 3xl:mx-auto px-8 sm:px-10 mb-6"><LazyLoadImage className='text-center mx-auto' src={ imageSrc } alt={ 'section-image' }/></div>)
      }
    </div>
  )
}

export default AdditionalCommentsComponent;